import './CategoryFilters.css';
import React from 'react';
import { get } from '../../../../utils';
import CarouselProvider from '../../../atoms/CarouselProvider/CarouselProvider';
import useMobile from '../../../../utils/useMobile';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../utils/tealium';
const transition = '0.3s linear';
const CategoryFilters = _ref => {
  let {
    categories,
    chosenTypes,
    checkboxesRef,
    withMapModalView = false,
    submitFilters,
    rtl,
    analytics,
    params
  } = _ref;
  const isMobile = useMobile(769);
  const renderCategoryItem = (category, index) => {
    const mainTitle = get(category, 'title.jss.value') || '';
    const title = get(category, 'contentType.type.template.targetItem.value') || '';
    const itemSearchIndex = get(category, 'searchIndex.jss.fields.IndexName.value') || '';
    const nestedFilters = get(category, 'filters') || [];
    const svgIcon = get(category, 'svg.jss.value');
    const color = get(category, 'colourTheme.item.backgroundColor.jss.value') || 'var(--m113-interactive-map-background-color)';
    const key = `${title}-${index}`;
    const isChecked = chosenTypes.length && chosenTypes.filter(el => el.value === title).length ? true : false;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: "imfilter-checkbox-item",
      style: {
        '--m114-imfilter-checkbox-color': color
      }
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: title,
      type: "checkbox",
      checked: isChecked,
      "data-search-index": itemSearchIndex,
      "data-mainTitle": mainTitle,
      className: `imfilter-checkbox`,
      id: `imfilter-${title}-${index}`,
      name: "imfilter",
      title: title,
      onChange: e => {
        tealiumClickFunc(tealiumMergeClickData(analytics['categoryAnalytics'], params), `${mainTitle ? mainTitle : ''}`);
        submitFilters(e, key, index, nestedFilters);
      },
      onKeyPress: event => {
        tealiumClickFunc(tealiumMergeClickData(analytics['categoryAnalytics'], params), `${mainTitle ? mainTitle : ''}`);
        submitFilters(event, key, index, nestedFilters);
      }
    }), (mainTitle || svgIcon) && /*#__PURE__*/React.createElement("label", {
      className: "imfilter-checkbox__label",
      htmlFor: `imfilter-${title}-${index}`
    }, svgIcon && /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svgIcon
      },
      className: "imfilter-checkbox__svg"
    }), /*#__PURE__*/React.createElement("span", {
      className: "imfilter-checkbox-title ellipsis1"
    }, " ", mainTitle)));
  };
  const renderItems = () => {
    if (categories && categories.length) {
      return categories.map((item, index) => renderCategoryItem(item, index));
    }
    return [];
  };
  if (!categories) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (categories && !categories.length) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (withMapModalView) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, !isMobile ? categories && categories.length && /*#__PURE__*/React.createElement("div", {
    className: "imfilters-categories imfilters-padding",
    ref: checkboxesRef
  }, categories.map((item, index) => renderCategoryItem(item, index))) : /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "imfilters-categories imfilters-padding",
      ref: checkboxesRef
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1200
          },
          items: 3,
          partialVisibilityGutter: 150
        },
        tabletLarge: {
          breakpoint: {
            max: 1199,
            min: 768
          },
          items: 3,
          partialVisibilityGutter: categories.length === 2 ? undefined : 20
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 2,
          partialVisibilityGutter: categories.length === 2 ? undefined : 50
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 2,
          partialVisibilityGutter: categories.length === 2 ? undefined : 50
        }
      },
      containerClass: '',
      partialVisible: categories.length < 3 ? false : true
    })));
  }));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${commonStyles}  ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c1ewc83s";
const ltrStyles = "lr5qox2";
const rtlStyles = "rthh9m6";
export default CategoryFilters;